<template>
  <div :class="['p-chat-date-divider', `p-chat-date-divider--${variant ?? 'today'}`]">
    <span class="p-chat-date-divider__label">{{ label }}</span>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  /** Display label, e.g. "Bugün" or "11 Eki Paz, 9:02" */
  label: string
  /** today: small pill with border; cross-day: bold inline date+time */
  variant?: 'today' | 'cross-day'
}>()
</script>

<style lang="scss" scoped>
.p-chat-date-divider {
  display: flex;
  justify-content: center;
  padding: 8px 0;

  &__label {
    font-size: 12px;
    line-height: 14px;
    font-weight: 500; // Utility/Utility 12 (Medium) per Figma node 5192:16604
    color: var(--fg-primary);
    white-space: nowrap;
  }

  &--today &__label {
    background: var(--bg-white);
    border: 1px solid var(--stroke-medium); // #ebebeb per Figma
    border-radius: 999px;
    padding: 4px 8px; // Figma: py-xsmall(4px) px-msmall(8px)
  }

  &--cross-day &__label {
    font-weight: 500;
    color: var(--fg-secondary);
  }
}
</style>
